export const getStoredPageSize = (name, defaultSize = 10) => {
  try {
    const key = `tableBox_pageSize_${name?.replace(/\s+/g, "_")}`
    const value = localStorage.getItem(key)
    return value ? parseInt(value, 10) : defaultSize
  } catch {
    return defaultSize
  }
}

export const storePageSize = (name, size) => {
  try {
    const key = `tableBox_pageSize_${name?.replace(/\s+/g, "_")}`
    localStorage.setItem(key, size.toString())
  } catch {}
}

const DENSITY_KEY = "dm.tableDensity"

export const getTableDensity = () => {
  try {
    return localStorage.getItem(DENSITY_KEY) === "compact" ? "compact" : "comfortable"
  } catch {
    return "comfortable"
  }
}

export const storeTableDensity = (density) => {
  try {
    localStorage.setItem(DENSITY_KEY, density)
  } catch {}
}

const VIEWS_KEY = "dm.inventoryViews"

export const getInventoryViews = () => {
  try {
    const raw = localStorage.getItem(VIEWS_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export const saveInventoryView = (view) => {
  const views = getInventoryViews().filter((item) => item.name !== view.name)
  views.unshift(view)
  localStorage.setItem(VIEWS_KEY, JSON.stringify(views.slice(0, 8)))
  return views.slice(0, 8)
}

export const deleteInventoryView = (name) => {
  const views = getInventoryViews().filter((item) => item.name !== name)
  localStorage.setItem(VIEWS_KEY, JSON.stringify(views))
  return views
}
